import { Form, Formik } from "formik";
import React from "react";
import SharedPasswordField from "../../components/Shared/SharedPasswordField";
import SharedButton from "../../components/Shared/SharedButton";
import Spinner from "../../components/Shared/Spinner";
import { FaLock, FaRegUser } from "react-icons/fa6";
import TextIconInput from "../../components/Shared/TextIconInput";
import { useTranslation } from "react-i18next";

function LoginForm({
  isLoading,
  handleSubmit,
  initialValues,
  validationSchema,
}) {
  const { t, i18n } = useTranslation();
  return (
    <React.Fragment>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        <Form className="flex flex-col gap-4">
          <div className="flex items-end gap-2 justify-center">
            <TextIconInput
              label={t("username")}
              name="employee_id"
              isIcon={true}
              placeholder={t("Enteryourusername")}
              icon={<FaRegUser className="text-primary" />}
              iconPos={i18n.language == "en" ? "left" : "right"}
              className="!p-1.5"
            />
          </div>
          <SharedPasswordField
            label={t("password")}
            name="password"
            type="password"
            isIcon
            placeholder={t("Enteryourpassword")}
            toggleMask
            icon={<FaLock className="text-primary" />}
            iconPos={i18n.language == "en" ? "left" : "right"}
            className="!p-1.5"
          />
          <SharedButton
            label={isLoading ? <Spinner /> : t("login")}
            className="submit-btn"
            type="submit"
            disabled={isLoading}
          />
        </Form>
      </Formik>
    </React.Fragment>
  );
}

export default LoginForm;
